import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BreadcrumbsCustom from 'src/components/common/BreadcrumbsCustom';
import Edit from 'src/components/templates/MailEdit';
import { getAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

const breadcrumbsDefine = [
  {
    to: '/master/email',
    label: 'リマインドメール',
  },
  {
    label: '変更',
  },
];

const MailEdit = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const emailId = searchParams.get('id');
  const token = getToken();
  const [email, setEmail] = useState(null);

  const getEmail = () => {
    try {
      getAPI(`/master/email-view?id=${emailId}&token=${token}`).then((res) => {
        if (res && res.code === 200) {
          setEmail(res.data);
        } else {
          navigate('/master/email');
        }
      });
    } catch (error) {
      navigate('/master/email');
      console.error('Failed to fetch data:', error);
      return;
    }
  };

  useEffect(() => {
    getEmail();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <BreadcrumbsCustom breadcrumbs={breadcrumbsDefine} />
      <Stack spacing={'20px'} width={'auto'}>
        <Edit email={email}/>
      </Stack>
    </>
  );
};

export default MailEdit;
